import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// Import required modules
import { Pagination } from "swiper/modules";
export const Service = () => {
  return (
    <section
      className="flat-spacing-1 flat-iconbox wow fadeInUp"
      data-wow-delay="0s"
    >
      <div className="container">
        <div className="wrap-carousel wrap-mobile">
          <Swiper
            spaceBetween={30}
            freeMode={true}
            pagination={{ clickable: true }}
            breakpoints={{
              1024: { slidesPerView: 4, spaceBetween: 10 }, // Desktop: 3 slides
              768: { slidesPerView: 2, spaceBetween: 15 }, // Tablet: 2 slides
              480: { slidesPerView: 1, spaceBetween: 15 }, // Mobile: 1 slide
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            <div className="swiper-wrapper wrap-iconbox">
              <SwiperSlide>
                <div className="tf-icon-box style-row">
                  <div className="icon">
                    <i className="icon-shipping"></i>
                  </div>
                  <div className="content">
                    <div className="title fw-4">Free Delivery</div>
                    <p>Within 2 km</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="tf-icon-box style-row">
                  <div className="icon">
                    <i className="icon-payment fs-22"></i>
                  </div>
                  <div className="content">
                    <div className="title fw-4">Flexible Payment</div>
                    <p>Pay with Multiple Credit Cards</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="tf-icon-box style-row">
                  <div className="icon">
                    <i className="icon-return fs-20"></i>
                  </div>
                  <div className="content">
                    <div className="title fw-4">Order on the Go</div>
                    <p>Our App Coming Soon</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="tf-icon-box style-row">
                  <div className="icon">
                    <i className="icon-suport"></i>
                  </div>
                  <div className="content">
                    <div className="title fw-4">Available for You</div>
                    <p>Online Support 24/7</p>
                  </div>
                </div>
              </SwiperSlide>
            </div>
          </Swiper>

          {/* Pagination Dots */}
          <div className="sw-dots style-2 sw-pagination-mb justify-content-center"></div>
        </div>
      </div>
    </section>
  );
};
